const Catalog = 'Catalog';

export const FETCH_CATALOGS_REQUEST = `${Catalog}/FETCH_CATALOGS_REQUEST`;
export const FETCH_CATALOGS_RESPONSE = `${Catalog}/FETCH_CATALOGS_RESPONSE`;
export const FETCH_CATALOGS_ERROR = `${Catalog}/FETCH_CATALOGS_ERROR`;

export const REMOVE_CATALOG_REQUEST = `${Catalog}/REMOVE_CATALOG_REQUEST`;
export const REMOVE_CATALOG_RESPONSE = `${Catalog}/REMOVE_CATALOG_RESPONSE`;
export const REMOVE_CATALOG_ERROR = `${Catalog}/REMOVE_CATALOG_ERROR`;

export const REMOVE_CATALOG_ITEM_REQUEST = `${Catalog}/REMOVE_CATALOG_ITEM_REQUEST`;
export const REMOVE_CATALOG_ITEM_RESPONSE = `${Catalog}/REMOVE_CATALOG_ITEM_RESPONSE`;
export const REMOVE_CATALOG_ITEM_ERROR = `${Catalog}/REMOVE_CATALOG_ITEM_ERROR`;

export const CREATE_CATALOG_REQUEST = `${Catalog}/CREATE_CATALOG_REQUEST`;
export const CREATE_CATALOG_RESPONSE = `${Catalog}/CREATE_CATALOG_RESPONSE`;
export const CREATE_CATALOG_ERROR = `${Catalog}/CREATE_CATALOG_ERROR`;

export const FETCH_PAGINATED_CATALOG_ITEMS_REQUEST = `${Catalog}/FETCH_PAGINATED_CATALOG_ITEMS_REQUEST`;
export const FETCH_PAGINATED_CATALOG_ITEMS_RESPONSE = `${Catalog}/FETCH_PAGINATED_CATALOG_ITEMS_RESPONSE`;
export const FETCH_PAGINATED_CATALOG_ITEMS_ERROR = `${Catalog}/FETCH_PAGINATED_CATALOG_ITEMS_ERROR`;

export const FETCH_CATALOG_NAMES_REQUEST = `${Catalog}/FETCH_CATALOG_NAMES_REQUEST`;
export const FETCH_CATALOG_NAMES_RESPONSE = `${Catalog}/FETCH_CATALOG_NAMES_RESPONSE`;
export const FETCH_CATALOG_NAMES_ERROR = `${Catalog}/FETCH_CATALOG_NAMES_ERROR`;

export const UPDATE_CATALOG_DISPLAY_SETTING = `${Catalog}/UPDATE_CATALOG_DISPLAY_SETTING`;

export const CHANGE_TABLE_COLUMNS = `${Catalog}/CHANGE_TABLE_COLUMNS`;
export const CHANGE_TABLE_PAGE_SIZE = `${Catalog}/CHANGE_TABLE_PAGE_SIZE`;
export const FILTER_TABLE = `${Catalog}/FILTER_TABLE`;
export const OPEN_CUSTOMIZE_TABLE_COLUMNS_MODAL = `${Catalog}/OPEN_CUSTOMIZE_TABLE_COLUMNS_MODAL`;
export const REFRESH_TABLE = `${Catalog}/REFRESH_TABLE`;
